if (!customElements.get('sunpura-strategy-chart')) {
  customElements.define('sunpura-strategy-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        if (!this.reduced.matches) return;
        this.observer?.disconnect();
        this.classList.remove('is-playing');
        this.played = true;
      };
      this.reduced.addEventListener('change', this.onMotionChange);
      if (this.played || this.dataset.motion !== 'true' || this.reduced.matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        if (this.reduced.matches || !this.isConnected) return;
        this.played = true;
        this.classList.add('is-playing');
      }, { threshold: 0.18 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.reduced?.removeEventListener('change', this.onMotionChange);
      this.bound = false;
    }
  });
}
